import { createAction, createSlice, isAnyOf } from '@reduxjs/toolkit'

import * as messages from 'redux/features/dataTables/messages/messagesSlice'
import * as auditLog from 'redux/features/dataTables/auditLog/auditLogSlice'
import * as atp from 'redux/features/dataTables/atp/atpSlice'
import { DataTableState } from 'types/redux/dataTables/dataTables'

export interface DataTablesState {
  messages: DataTableState
  auditLog: DataTableState
  atp: DataTableState
}

// initialState
export const INITIAL_STATE = {
  messages: messages.INITIAL_STATE,
  auditLog: auditLog.INITIAL_STATE,
  atp: atp.INITIAL_STATE
}

const reset = createAction('DATATABLES/reset/all')

/* eslint-disable no-param-reassign */
export const dataTablesSlice = createSlice({
  name: 'DATA_TABLES',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(reset, () => ({
        ...INITIAL_STATE
      }))
      .addMatcher(isAnyOf(messages.update, messages.reset), (state: DataTablesState, action) => {
        state.messages = { ...messages.default(state.messages, action) }
      })
      .addMatcher(isAnyOf(auditLog.update, auditLog.reset), (state: DataTablesState, action) => {
        state.auditLog = { ...auditLog.default(state.auditLog, action) }
      })
      .addMatcher(isAnyOf(atp.update, atp.reset), (state: DataTablesState, action) => {
        state.atp = { ...atp.default(state.atp, action) }
      })
  }
})
/* eslint-enable no-param-reassign */

export default dataTablesSlice.reducer
